module.exports = __webpack_public_path__ + "img/ticket_ex2.c9631b45.svg";